module.exports = __webpack_public_path__ + "static/title-9086d7c4cdbda6cfd6c18df18d32c14b.svg";